/* eslint-disable camelcase */
import * as React from 'react';
import { ISelectInputOption } from '@rocketmakers/armstrong';
import { FilterSelect, IFilterSelectProps } from '../../../shared/components/filter-select';

import { useZones } from '../hooks/zones';

export type ISelectZoneProps = Omit<IFilterSelectProps, 'options' | 'placeholder'>;

export const SelectZone: React.FunctionComponent<ISelectZoneProps> = (props) => {
  const { zones } = useZones();

  const options: ISelectInputOption[] = React.useMemo(
    () => (zones ? zones.map(({ zone_id, description }) => ({ id: zone_id, name: description })) : undefined),
    [zones],
  );

  return (
    <FilterSelect
      optionLabel={'Select a zone'}
      data-qa="select-zone"
      {...props}
      options={options}
      placeholder={!options ? 'Loading ... ' : undefined}
    />
  );
};
